import { useEffect } from "react"
import { isPdmStructureV2Enabled } from "../helpers/flags/isPdmStructureV2Enabled"
import {
  cancelPdmVehicleCatalogLoad,
  loadPdmVehicleCatalogIntoStore,
} from "../helpers/vehicle/loadPdmVehicleCatalogIntoStore"
import {
  clearPersistedPdmVehicleCatalog,
  usePdmVehicleCatalogStore,
} from "../store/pdm-vehicle-catalog-store"

/**
 * Load PDM products and populate picker catalog store (V2 only).
 * Currently unused — Layout owns loading via `useGlobalVehicleCatalogLoader`.
 * Kept for optional debug logging (`log: true`). Does not cancel on unmount.
 */
export function useLoadPdmVehicleCatalog(): void {
  const { actions } = usePdmVehicleCatalogStore()

  useEffect(() => {
    if (!isPdmStructureV2Enabled()) {
      cancelPdmVehicleCatalogLoad()
      actions.reset()
      clearPersistedPdmVehicleCatalog()
      return
    }

    void loadPdmVehicleCatalogIntoStore({ log: true })
  }, [actions])
}
